import {
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { WizardSection } from '@app/models/project-setup.models';
import { WizardStore } from '@app/stores/project-setup/wizard.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { ValidatedTextAreaComponent } from '@app/ui-components/validated-textarea/validated-textarea.component';
import { SectionIFormGroup } from '../+helpers/section-i-form.helper';

@Component({
  selector: 'app-section-i',
  imports: [ReactiveFormsModule, CardComponent, ValidatedTextAreaComponent],
  templateUrl: './section-i.component.html',
  styleUrl: './section-i.component.scss',
})
export class SectionIComponent implements OnInit {
  wizardStore = inject(WizardStore);
  projectId = input.required<string>();
  protected formGroup = signal<FormGroup<SectionIFormGroup> | null>(null);
  protected translationKey = 'projectWizard.sectionIForm.';

  constructor(private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.wizardStore
      .getSection(this.projectId(), WizardSection.I)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) =>
        this.formGroup.set(data as FormGroup<SectionIFormGroup>)
      );
  }
}
